import { faEllipsis } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { use, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import usePrivileges from "../../../../Auth/usePrivileges";
import { LotDetailContext } from "../../../../Contexts/LotDetailContext";
import SelectPackageTypeDialog from "../../../../Dialogs/SelectPackageTypeDialog";

export function MaterialCodeFields() {
    const { t } = useTranslation();

    const {
        lotDetail: {
            summary: {
                currentStatus,
                packageType,
                materialCode,
                businessUnitCode
            }
        },
    } = use(LotDetailContext);

    const { canGrade, admin } = usePrivileges(businessUnitCode);
    const [showSelectPackageTypeDialog, setShowSelectPackageTypeDialog] = useState(false);

    return (
        <>
            <Form.Group as={Col} sm={6} controlId="formPackageType">
                <Row>
                    <Form.Label column sm={4}>{t('LotDetails.Summary.PackageType')}:</Form.Label>
                    <Col sm={8}>
                        <div className="d-flex justify-content-start">
                            <Form.Control type="text" disabled value={packageType ?? ""} />
                            {(admin || canGrade) && currentStatus !== "Graded" &&
                                <Button variant="light" className="ms-2" onClick={() => setShowSelectPackageTypeDialog(true)} >
                                    <FontAwesomeIcon icon={faEllipsis} />
                                </Button>
                            }
                        </div>
                    </Col>
                </Row>
            </Form.Group>
            <Form.Group as={Col} sm={6} controlId="formMaterialCode">
                <Row>
                    <Form.Label column sm={4}>{t('LotDetails.Summary.MaterialCode')}:</Form.Label>
                    <Col sm={8}>
                        <div className="d-flex justify-content-start">
                            <Form.Control type="text" disabled value={materialCode ?? ""} />
                            {(admin || canGrade) && currentStatus !== "Graded" &&
                                <Button variant="light" className="ms-2" onClick={() => setShowSelectPackageTypeDialog(true)} >
                                    <FontAwesomeIcon icon={faEllipsis} />
                                </Button>
                            }
                        </div>
                    </Col>
                </Row>
            </Form.Group>
            <SelectPackageTypeDialog showDialog={showSelectPackageTypeDialog} closeDialog={() => setShowSelectPackageTypeDialog(false)} />
        </>
    );
}